export default __webpack_public_path__ + "static/media/AmazonBasics1.0b24d3a7.jpg";